import {
  registerHandle,
  resolve,
  summarizeRef,
  type ResolvedRef,
  type Source,
  SourceSchema,
} from '@/agent/refs';
import type { Tool } from './types';

type Input = { source: Source };

export const computeExtent: Tool<Input> = {
  name: 'compute_extent',
  description:
    'Return the bounding extent of a Source. Cheap when the geometry is already in a handle.',
  input_schema: {
    type: 'object',
    properties: { source: SourceSchema },
    required: ['source'],
    additionalProperties: false,
  },
  execute: async ({ source }) => {
    const ref = await resolve(source);
    if (!ref.extent) throw new Error('compute_extent: source has no derivable extent');
    const newRef: ResolvedRef = {
      source_kind: 'extent',
      extent: ref.extent,
      geometry: ref.extent,
    };
    const handle = registerHandle(newRef);
    return {
      handle,
      extent: {
        xmin: ref.extent.xmin,
        ymin: ref.extent.ymin,
        xmax: ref.extent.xmax,
        ymax: ref.extent.ymax,
        wkid: ref.extent.spatialReference?.wkid ?? undefined,
      },
      summary: summarizeRef(newRef),
    };
  },
};
